import request from '@/utils/request'

// 取消工作计划
export function workPlanListByPage(data) {
  return request({
    url: '/workPlan/listByPage',
    method: 'post',
    data: data
  })
}

// 保存工作计划
export function saveWorkPlan(data) {
  return request({
    url: '/workPlan/save',
    method: 'post',
    data: data
  })
}

// 取消工作计划
export function cancelWorkPlan(data) {
  return request({
    url: '/workPlan/cancel',
    method: 'post',
    data: data
  })
}

// 完成工作计划
export function completeWorkPlan(data) {
  return request({
    url: '/workPlan/complete',
    method: 'post',
    data: data
  })
}

// 工作计划详情
export function workPlanDetail(data) {
  return request({
    url: '/workPlan/detail',
    method: 'get',
    params: data
  })
}
